module.exports = __webpack_public_path__ + "img/9.8b64ca2a.jpg";